import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#97d400',
        secondary: colors.purple.base, // #FFCDD2
        accent: colors.blue.base, // #3F51B5
        grey: colors.grey.otto,
      },
    },
  },
});
